
import { PROJECT_INFO } from "~/constants";

export default {
    props: {
        project: {
            type: Object,
            default: () => PROJECT_INFO,
        },
    },
    data() {
        return {
            projects: this.project.projects,
            projectInfo: this.project,
        };
    },
    methods: {
        requireSrc(img) {
            return require(`~/assets/images/roadshow-taiwan/${img}`);
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
    },
};
